import { Cell, Pie, PieChart, ResponsiveContainer, Tooltip } from 'recharts';
import pluralize from 'pluralize';
import React from 'react';
import { useWindowSize } from '../../../../lib/utils.js';

export const ImpactTypeChart = (props) => {
  const { results, textProps, renderLabel, changeImpactTypes, pieTypeRef } =
    props;

  const colors = [
    'var(--color--pale-teal)',
    'var(--color--dark-sky-blue)',
    'var(--color--dark-blue-grey)',
    'var(--color--marigold)',
    'var(--color--faded-red)',
    'var(--color--amethyst)',
    'var(--color--pine-glade)',
    'var(--color--nepal)',
    'var(--color--saffron)',
    'var(--color--mauvelous)',
    'var(--color--waikawa-gray)',
    'var(--color--anzac)',
    'var(--color--light-wisteria)',
    'var(--color--olivine)',
  ];

  const size = useWindowSize();

  const resultsByType = changeImpactTypes
    .map((type) => [
      ...results.filter(
        (item) => item.changeImpactType && item.changeImpactType.id === type.id
      ),
    ])
    .filter((result) => result.length);

  const data = resultsByType.map((arr) => {
    return {
      name: arr[0].impactType,
      archived: arr[0].changeImpactType.archived,
      value: Math.round((arr.length / results.length) * 100),
      count: arr.length,
    };
  });

  const height = data.length / 0.2 + 350;

  const colorCalc = (entry, index) => {
    const isLastItem = index === data.length - 1;
    const alternateLastColor = isLastItem && data.length % colors.length === 1;

    return alternateLastColor ? colors[2] : colors[index % colors.length];
  };

  return (
    <div ref={pieTypeRef}>
      <ResponsiveContainer
        id="impact-type-chart-container"
        height={height}
        width={size.width < 1400 ? size.width / 2 - 30 : undefined}
      >
        <PieChart>
          <text {...textProps} x="50%" y="50%" fontSize={28}>
            {results.length}
          </text>
          <text {...textProps} x="50%" y="50%" dy="20">
            {pluralize('Impact', results.length)}
          </text>
          <Pie
            data={data}
            dataKey="count"
            innerRadius={size.width > 1400 ? 60 : 45}
            outerRadius={size.width > 1400 ? 90 : 60}
            isAnimationActive={false}
            startAngle={90}
            endAngle={-270}
            label={renderLabel}
            labelLine={false}
          >
            {data.map((entry, index) => {
              return (
                <Cell
                  key={index}
                  fill={colorCalc(entry, index)}
                  stroke="none"
                />
              );
            })}
          </Pie>
          {data.map((entry, index) => {
            return (
              <Tooltip
                key={index}
                contentStyle={{
                  background: 'var(--color--light-pale-grey)',
                  borderColor: 'var(--color--silver)',
                  borderRadius: 4,
                  padding: '4px 10px',
                }}
                itemStyle={{ color: 'var(--color--dark-blue-grey)' }}
                separator=" &bull; "
              />
            );
          })}
        </PieChart>
      </ResponsiveContainer>
    </div>
  );
};
